import { withStyles } from '@material-ui/core';
import StatusBadge from './StatusBadge';
import styles from './styles';

export default withStyles(styles)(StatusBadge);
